import React from 'react';
import { Container } from 'reactstrap';
import { Route, Routes } from 'react-router-dom';

import List from "./List";
import { FitnessProgramForm } from "./Form";

import { FITNESS_GROUP_ROUTES } from './config';
import FitnessProgramDetails from "./Details";

export default function Fitness() {

    return (
        <Container fluid className="content">
            <Routes>
                <Route
                    path={FITNESS_GROUP_ROUTES.LISTS}
                    element={<List/>}
                />

                <Route
                    path={FITNESS_GROUP_ROUTES.FORM}
                    element={<FitnessProgramForm/>}
                />

              <Route
                path={FITNESS_GROUP_ROUTES.DETAILS}
                element={<FitnessProgramDetails/>}
              />

            </Routes>
        </Container>
    );
}